module.exports = __webpack_public_path__ + "static/media/blueIndicator.b0d498c0.svg";